import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-9b3a6bee"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "compras-container" };
const _hoisted_2 = { class: "dashboard" };
const _hoisted_3 = { class: "compras-main" };
const _hoisted_4 = { class: "content-header" };
const _hoisted_5 = { class: "header-left" };
const _hoisted_6 = { class: "header-icon-bg" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h1", { class: "title" }, "Gestión de Compras"),
    /*#__PURE__*/ _createElementVNode("p", { class: "subtitle" }, "Almacén Principal · Flujo completo desde emisión hasta inventario")
], -1 /* HOISTED */));
const _hoisted_8 = { class: "phases-stepper" };
const _hoisted_9 = { class: "step-icon-wrap" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "step-info" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "step-num" }, "Fase 1"),
    /*#__PURE__*/ _createElementVNode("span", { class: "step-name" }, "Órdenes Emitidas")
], -1 /* HOISTED */));
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "step-connector" }, null, -1 /* HOISTED */));
const _hoisted_12 = { class: "step-icon-wrap" };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "step-info" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "step-num" }, "Fase 2"),
    /*#__PURE__*/ _createElementVNode("span", { class: "step-name" }, "Recepción")
], -1 /* HOISTED */));
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "step-connector" }, null, -1 /* HOISTED */));
const _hoisted_15 = { class: "step-icon-wrap" };
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "step-info" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "step-num" }, "Fase 3"),
    /*#__PURE__*/ _createElementVNode("span", { class: "step-name" }, "Auditoría")
], -1 /* HOISTED */));
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "step-connector" }, null, -1 /* HOISTED */));
const _hoisted_18 = { class: "step-icon-wrap" };
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "step-info" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "step-num" }, "Fase 4"),
    /*#__PURE__*/ _createElementVNode("span", { class: "step-name" }, "Transferencia")
], -1 /* HOISTED */));
const _hoisted_20 = { class: "phase-content-card" };
import { ref, computed } from 'vue';
import { hasPermission as can } from '@/store/userStore';
import { PERMISSIONS as P } from '../../constants/permissions';
import Sidebar from "@/components/Sidebar.vue";
import Header from "@/components/HeaderDashboard.vue";
import { PackageIcon, CloudUploadIcon, TruckIcon, CalculatorIcon, DatabaseIcon } from 'lucide-vue-next';
import Fase1Emision from './tabs/Fase1Emision.vue';
import Fase2Recepcion from './tabs/Fase2Recepcion.vue';
import Fase3Verificacion from './tabs/Fase3Verificacion.vue';
import Fase4Transferencia from './tabs/Fase4Transferencia.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const currentTab = ref('emision');
        const pasosDone = ref([]);
        const currentComponent = computed(() => {
            switch (currentTab.value) {
                case 'emision': return Fase1Emision;
                case 'recepcion': return Fase2Recepcion;
                case 'verificacion': return Fase3Verificacion;
                case 'transferencia': return Fase4Transferencia;
                default: return Fase1Emision;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Header),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(Sidebar),
                    _createElementVNode("div", _hoisted_3, [
                        _createCommentVNode(" ── PAGE HEADER ── "),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    _createVNode(_unref(PackageIcon), {
                                        size: 24,
                                        class: "text-white"
                                    })
                                ]),
                                _hoisted_7
                            ])
                        ]),
                        _createCommentVNode(" ── STEPPER DE FASES ── "),
                        _createElementVNode("div", _hoisted_8, [
                            (_unref(can)(_unref(P).COMPRAS.PEDIDOS))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass(["phase-step", { active: currentTab.value === 'emision', done: pasosDone.value.includes('emision') }]),
                                    onClick: _cache[0] || (_cache[0] = ($event) => (currentTab.value = 'emision'))
                                }, [
                                    _createElementVNode("div", _hoisted_9, [
                                        _createVNode(_unref(CloudUploadIcon), { size: 20 })
                                    ]),
                                    _hoisted_10,
                                    _hoisted_11
                                ], 2 /* CLASS */))
                                : _createCommentVNode("v-if", true),
                            (_unref(can)(_unref(P).COMPRAS.RECEPCION))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: _normalizeClass(["phase-step", { active: currentTab.value === 'recepcion', done: pasosDone.value.includes('recepcion') }]),
                                    onClick: _cache[1] || (_cache[1] = ($event) => (currentTab.value = 'recepcion'))
                                }, [
                                    _createElementVNode("div", _hoisted_12, [
                                        _createVNode(_unref(TruckIcon), { size: 20 })
                                    ]),
                                    _hoisted_13,
                                    _hoisted_14
                                ], 2 /* CLASS */))
                                : _createCommentVNode("v-if", true),
                            (_unref(can)(_unref(P).COMPRAS.VERIFICACION))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    class: _normalizeClass(["phase-step", { active: currentTab.value === 'verificacion', done: pasosDone.value.includes('verificacion') }]),
                                    onClick: _cache[2] || (_cache[2] = ($event) => (currentTab.value = 'verificacion'))
                                }, [
                                    _createElementVNode("div", _hoisted_15, [
                                        _createVNode(_unref(CalculatorIcon), { size: 20 })
                                    ]),
                                    _hoisted_16,
                                    _hoisted_17
                                ], 2 /* CLASS */))
                                : _createCommentVNode("v-if", true),
                            (_unref(can)(_unref(P).COMPRAS.TRANSFERENCIA))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 3,
                                    class: _normalizeClass(["phase-step last", { active: currentTab.value === 'transferencia', done: pasosDone.value.includes('transferencia') }]),
                                    onClick: _cache[3] || (_cache[3] = ($event) => (currentTab.value = 'transferencia'))
                                }, [
                                    _createElementVNode("div", _hoisted_18, [
                                        _createVNode(_unref(DatabaseIcon), { size: 20 })
                                    ]),
                                    _hoisted_19
                                ], 2 /* CLASS */))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _createCommentVNode(" ── CONTENIDO DE LA FASE ── "),
                        _createElementVNode("div", _hoisted_20, [
                            _createVNode(_Transition, {
                                name: "fade-slide",
                                mode: "out-in"
                            }, {
                                default: _withCtx(() => [
                                    (_openBlock(), _createBlock(_resolveDynamicComponent(currentComponent.value)))
                                ]),
                                _: 1 /* STABLE */
                            })
                        ])
                    ])
                ])
            ]));
        };
    }
});
